import React from 'react';
import './RouteFallback.css';

/**
 * What a lazy route shows while its chunk is on the way.
 *
 * This replaced `<div>Loading...</div>` — unstyled black text at the top left
 * of a white page, which on a phone reads as the app having broken rather than
 * as the app working. It is the screen a scorer sees between tapping a tab and
 * the page arriving, so it has to look like this app: the navy header band
 * every screen in it carries, and a quiet shimmer under it.
 *
 * It is deliberately a SHELL, not a mimic of any one page. Every lazy route in
 * `App.js` shares this fallback, and a skeleton shaped like the leaderboard
 * would be a small lie on the way to the scorecard.
 *
 * It lives in the MAIN BUNDLE, which is the whole point: a fallback that had
 * to be downloaded could not be shown while something was downloading.
 */
const RouteFallback = () => (
  <div className="route-fallback" role="status" aria-label="Loading">
    <div className="route-fallback-bar" />
    <div className="route-fallback-body">
      <span className="route-fallback-line route-fallback-line--wide" />
      <span className="route-fallback-line" />
      <span className="route-fallback-line route-fallback-line--short" />
    </div>
  </div>
);

export default RouteFallback;
